import {
  Button,
  Card,
  CardContent,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { Buffer } from "buffer";
import { fetchApplicationReferralsExternalUser } from "../../../services/applicationReferral";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";
import GovGrButton from "../../../components/GovGrButton";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  viewDetails: {
    width: 700,
    height: 400,
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
  },
  cardContent: {
    padding: "20px",
    marginTop: 15,
    marginBottom: 15,
  },
  button: {
    margin: "1rem",
  },
});

const SeeReferrals = ({ id }) => {
  const classes = useStyles();
  const { t } = useLocale();
  const { data: referrals } = useQuery(
    ["referralsWithIdExternalUser", id],
    () => fetchApplicationReferralsExternalUser(id)
  );
  if (referrals?.length <= 0) {
    <Typography>{t("No referrals")}</Typography>;
  }

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContainer}>
        {referrals?.map((referral, index) => (
          <Card
            key={referral.id}
            className={classes.cardContent}
            variant="outlined"
          >
            <CardContent>
              <Typography variant="h4" gutterBottom>
                {index + 1}. {referral.dscr}
              </Typography>
            </CardContent>
            <GovGrButton
              buttonText={t("View")}
              onClick={() => {
                const blob = new Blob(
                  [Buffer.from(referral?.referral_doc?.data)],
                  {
                    type: referral?.content_type,
                  }
                );
                let url = window.URL.createObjectURL(blob);

                window.open(url, "_blank");
                // let a = document.createElement("a");
                // a.href = url;
                // a.download = referral?.file_name;
                // a.click();
              }}
            />
          </Card>
        ))}
      </CardContent>
    </Card>
  );
};

export default SeeReferrals;
